import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const servicePackageSlice = createApi({
  reducerPath: "servicePackageSlice",

  baseQuery: fetchBaseQuery({
    baseUrl: beautyBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({

    // ✅ Get all service packages
    getServicePackages: builder.query({
      query: ({ page = 1, limit = 10, search = "" }) => ({
        url: `/productpackage?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
      transformResponse: (response) => response,
    }),

    // ✅ Get category-based package services
    getCategoryBasedPackageServices: builder.mutation({
      query: (id) => ({
        url: `/product/category/${id}?limit=1000`,
        method: "GET",
      }),
    }),

    // ✅ Add new service package
    addServicePackage: builder.mutation({
      query: (body) => ({
        url: "/productpackage",
        method: "POST",
        body,
      }),
    }),

    // ✅ Get single service package by ID
    getSingleServicePackage: builder.query({
      query: (id) => ({
        url: `/productpackage/${id}`,
        method: "GET",
      }),
    }),

    // ✅ Update existing service package
    updateServicePackage: builder.mutation({
      query: ({ id, body }) => ({
        url: `/productpackage/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // ✅ Delete service package
    deleteServicePackage: builder.mutation({
      query: (id) => ({
        url: `/productpackage/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

// ✅ Export all hooks
export const {
  useGetServicePackagesQuery,
  useGetCategoryBasedPackageServicesMutation,
  useAddServicePackageMutation,
  useGetSingleServicePackageQuery,
  useUpdateServicePackageMutation,
  useDeleteServicePackageMutation,
} = servicePackageSlice;
